<template>
  <div class="columns">
    <div class="column">
      <window title="Password-strenght-meter <a href='https://github.com/skegel13/vue-password'
                                                target='_blank'>(more info)">
        <form>
          <label for="email">Email</label>
          <p class="control">
            <input id="email" class="input" type="email" name="email" v-model="user.email">
          </p>
          <label for="password">Password</label>
          <p class="control">
            <vue-password v-model="user.password" classes="input" :user-inputs="[user.email]">
            </vue-password>
          </p>
        </form>
      </window>
    </div>
  </div>
</template>

<script>
import VuePassword from 'vue-password';

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
    };
  },
  components: { VuePassword },
};
</script>
